import { render, staticRenderFns } from "./ProductCatalogueList.vue?vue&type=template&id=2a33ab62&scoped=true&"
import script from "./ProductCatalogueList.vue?vue&type=script&lang=js&"
export * from "./ProductCatalogueList.vue?vue&type=script&lang=js&"
import style0 from "./ProductCatalogueList.vue?vue&type=style&index=0&id=2a33ab62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33ab62",
  null
  
)

export default component.exports